const Maquina = {
    id: 0,
    nome: "",
    ativo: true
}

export default Maquina;